import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { Api } from "src/api/api";
import reviewSlice from "src/features/review-slice";

const rootReducer = combineReducers({
  review: reviewSlice,
  [Api.reducerPath]: Api.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([Api.middleware]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
